@if (!disabled) {
  <div class="editable-field-wrapper">
    <div cdkOverlayOrigin #origin="cdkOverlayOrigin">
      <div class="vitamui-input editable-field" [class.edit-mode]="editMode" (click)="enterEditMode()">
        <div class="editable-field-content">
          <label>{{ label }}</label>
          <span class="editable-field-text-content display-all">{{ control?.value }}</span>
          <div class="editable-field-control">
            <textarea [formControl]="control" [maxlength]="maxlength" [required]="required" rows="3" #input></textarea>
          </div>
        </div>
        @if (!showSpinner && !editMode) {
          <i class="material-icons edit-icon">edit</i>
        }
        @if (showSpinner) {
          <div>
            <mat-spinner diameter="24" color="accent"></mat-spinner>
          </div>
        }
      </div>
    </div>
    <div class="vitamui-input-errors">
      <ng-content select="vitamui-common-field-error"></ng-content>
    </div>
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOpen]="editMode"
      [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayPositions]="positions"
    >
      <div class="editable-field-actions">
        <button type="button" class="editable-field-confirm" (click)="confirm()" [disabled]="!canConfirm">
          <i class="material-icons">check</i>
        </button>
        <button type="button" class="editable-field-cancel" (click)="cancel()"><i class="material-icons">clear</i></button>
      </div>
    </ng-template>
  </div>
}

@if (disabled) {
  <div class="read-only-field">
    <label>{{ label }}</label>
    <div>{{ control?.value }}</div>
  </div>
}
